"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var owa_options_controls_1 = require("owa-options-controls");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var owa_outlook_service_options_1 = require("owa-outlook-service-options");
var selectQuickSuggestionOption_1 = require("../actions/selectQuickSuggestionOption");
var owa_options_core_1 = require("owa-options-core");
var QuickSuggestionsFull = /** @class */ (function (_super) {
    tslib_1.__extends(QuickSuggestionsFull, _super);
    function QuickSuggestionsFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuickSuggestionsFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var isEnabled = owa_options_core_1.getFallbackValueIfNull(optionStore.smartSuggestionsEnabled, userOptions.smartSuggestionsEnabled);
        var useLocation = owa_options_core_1.getFallbackValueIfNull(optionStore.browserLocationEnabled, userOptions.browserLocationEnabled);
        return (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_mail_quickSuggestionsDescription),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: isEnabled, label: owa_options_strings_1.default.options_mail_quickSuggestionsEnable, onChange: this.toggleEnable }),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { disabled: !isEnabled, checked: useLocation, label: owa_options_strings_1.default.options_mail_quickSuggestionsLocation, onChange: this.toggleLocation })));
    };
    QuickSuggestionsFull.prototype.toggleEnable = function (ev, checked) {
        selectQuickSuggestionOption_1.default('smartSuggestionsEnabled', checked);
    };
    QuickSuggestionsFull.prototype.toggleLocation = function (ev, checked) {
        selectQuickSuggestionOption_1.default('browserLocationEnabled', checked);
    };
    QuickSuggestionsFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () {
                return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SmartSuggestions);
            },
        })
    ], QuickSuggestionsFull);
    return QuickSuggestionsFull;
}(React.Component));
exports.default = QuickSuggestionsFull;
//# sourceMappingURL=QuickSuggestionsFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-quick-suggestions-option/lib/components/QuickSuggestionsFull.js
// module id = 5132
// module chunks = 2